<template>
	<b-modal ref="modal" title="Upgrade" hide-footer size="lg">
		<template #modal-header>
			<div class="upgrade-header d-flex flex-wrap align-items-center w-100">
				<span class="modal-title upgrade-title">Upgrade</span>
				<div class="upgrade-period d-flex justify-content-center">
					<b-form-radio-group
						v-model="period"
						:options="periodOptions"
						buttons
					></b-form-radio-group>
				</div>
				<b-button-close @click="$refs.modal.hide()"/>
			</div>
		</template>
		<p v-if="message" class="upgrade-message">{{ message }}</p>
		<b-card-group deck class="mx-n2 plan-cards">
			<b-card bg-variant="secondary" class="text-center mx-2" body-class="d-flex flex-column">
				<h3>Free</h3>
				<ul class="pl-3 text-left">
					<li>Only 3 channels</li>
					<li>Widgets: Chat, Gift alerts, Viewer count, Highlighted message</li>
					<li>URL harvester</li>
					<li>Over 290 TTS voices<br /><a :href="`${$baseUrl}/voices/regular`">voice list</a></li>
				</ul>
			</b-card>
			<b-card bg-variant="secondary" class="text-center mx-2" :class="{ 'plan-highlighted': highlightedPlan === 'regular' }" body-class="d-flex flex-column">
				<h3>Regular</h3>
				<h5 class="mb-2"><b>${{ prices[period].regular }}</b>/{{ period === 'monthly' ? 'mo' : 'yr' }}</h5>
				<ul class="pl-3 text-left">
					<li>Unlimited channels</li>
					<li>Song requests</li>
					<li>All widgets from free tier, plus Dono goal, Word cloud and Emote wall</li>
					<li>Custom commands</li>
					<li>Over 290 TTS voices<br /><a :href="`${$baseUrl}/voices/regular`">voice list</a></li>
				</ul>
				<b-button v-if="user && user.is_regular && user.period === period" variant="secondary" disabled class="mt-auto">Current plan</b-button>
				<b-button v-else variant="success" :disabled="loading > 0" @click="checkout('regular')" class="mt-auto">Select plan</b-button>
			</b-card>
			<b-card bg-variant="secondary" class="text-center mx-2" :class="{ 'plan-highlighted': highlightedPlan === 'pro' }" body-class="d-flex flex-column">
				<h3>Pro</h3>
				<h5 class="mb-2"><b>${{ prices[period].pro }}</b>/{{ period === 'monthly' ? 'mo' : 'yr' }}</h5>
				<ul class="pl-3 text-left">
					<li>Unlimited channels</li>
					<li>All widgets</li>
					<li>Experimental restreaming</li>
					<li>Notification system supporting Discord, Telegram and many more.</li>
					<li>Custom commands with webhooks</li>
					<li>Over 1300 TTS voices<br /><a :href="`${$baseUrl}/voices/pro`">voice list</a></li>
				</ul>
				<b-button v-if="user && user.is_pro && user.period === period && user.subscription_status != 'gratuity'" variant="secondary" disabled class="mt-auto">Current plan</b-button>
				<b-button v-else variant="success" :disabled="loading > 0" @click="checkout('pro')" class="mt-auto">Select plan</b-button>
			</b-card>
		</b-card-group>
		<b-alert variant="danger" :show="!!error" class="mt-3">{{ error }}</b-alert>
	</b-modal>
</template>

<script>
export default {
	props: ['user'],
	data() { return {
		loading: 0,
		error: null,
		period: 'yearly',
		highlightedPlan: null,
		message: null,
		periodOptions: [
			{ text: 'Monthly', value: 'monthly' },
			{ html: 'Yearly <span class="badge badge-success">2 months free</span>', value: 'yearly' },
		],
		prices: {
			monthly: { regular: 4, pro: 8 },
			yearly: { regular: 40, pro: 80 },
		},
	}},
	methods: {
		show({ plan, period, message } = {}) {
			this.highlightedPlan = plan || null;
			this.period = period || this.user?.period || 'yearly';
			this.message = message || null;
			this.$refs.modal.show();
		},
		async checkout(plan) {
			this.loading++;
			this.error = null;
			try {
				const successUrl = `${this.$baseUrl}/app/account/billing?checkout=success&plan=${plan}&period=${this.period}`;
				const { url } = await this.$api.post('checkoutSession', {
					plan,
					period: this.period,
					successUrl,
					cancelUrl: window.location.href,
				});
				window.location.href = url;
			} catch(e) {
				this.error = e.message || String(e);
			} finally {
				this.loading--;
			}
		},
	},
};
</script>

<style scoped>
.upgrade-period {
	flex: 1;
}
.upgrade-message {
	font-size: 1.25rem;
	font-weight: bold;
	text-align: center;
	margin: 0 0 1rem;
}
.plan-highlighted {
	outline: 2px solid #28a745;
	box-shadow: 0 0 0 4px rgba(40, 167, 69, 0.25);
}

@media (max-width: 991px) {
	.upgrade-title {
		flex: 1;
	}
	.upgrade-period {
		flex-basis: 100%;
		order: 3;
		margin-top: 0.5rem;
	}
}

@media (min-width: 576px) and (max-width: 991px) {
	::v-deep .plan-cards {
		flex-direction: column;
	}
	::v-deep .plan-cards .card {
		margin: 0 0 1rem 0;
	}
}
</style>
